import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { getInfoHubRedirectBannerMessage } from '../constants/infohubBannerCopy';

const InfoHubRedirectBanner = ({ title, infohubUrl }) => {
  const message = getInfoHubRedirectBannerMessage(title);

  return (
    <Box
      sx={{
        backgroundColor: '#fff59b',
        padding: '24px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        borderRadius: '8px',
        marginTop: '24px',
      }}
    >
      <Link
        href={infohubUrl}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: 'black', textDecoration: 'none' }}
      >
        <Typography
          variant="h6"
          component="div"
          sx={{
            fontWeight: 'bold',
            textAlign: 'center',
            fontSize: '16px',
            color: 'black',
          }}
        >
          {message} <OpenInNewIcon style={{ fontSize: '16px', verticalAlign: 'middle', marginLeft: '4px' }} />
        </Typography>
      </Link>
    </Box>
  );
};

InfoHubRedirectBanner.propTypes = {
  title: PropTypes.string.isRequired,
  infohubUrl: PropTypes.string.isRequired,
};

export default InfoHubRedirectBanner;
